import { allTrackers } from "app/services/track/track";

import { createSignalRecommenderTrackingService } from "./factory";

const signalRecommenderTrackingService = createSignalRecommenderTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default signalRecommenderTrackingService;
